import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
// Supported locales
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';

import { useTranslation } from '../../../hooks/useTranslation';
import StyledDateRangePicker from './StyledDateRangePicker';

interface DateRangePickerProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onChange: (dateRange: [Dayjs | null, Dayjs | null]) => void;
  locale?: 'en' | 'fr' | 'de';
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  locale = 'en',
  onChange,
}) => {
  const { t } = useTranslation();

  // Ensure Day.js uses the correct locale
  dayjs.locale(locale);

  return (
    <StyledDateRangePicker>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
        <DatePicker
          value={startDate}
          onChange={date => onChange([date, endDate])}
          label={t('Start date')}
          format="DD/MM/YYYY"
        />
        <DatePicker
          value={endDate}
          onChange={date => onChange([startDate, date])}
          label={t('End date')}
          format="DD/MM/YYYY"
        />
      </LocalizationProvider>
    </StyledDateRangePicker>
  );
};

export default DateRangePicker;
